"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var AmenityList_1 = __importDefault(require("../../AmenityList"));
var SectionHeader_1 = __importDefault(require("../../SectionHeader"));
var AnimalsRow_1 = __importDefault(require("../../DeveloperPostContent/DeveloperPostSections/ApartmentsSection/ApartmentsTable/ApartmentTableRow/AnimalsRow"));
var PostViewContentTypes_1 = require("../../../../constants/PostViewContentTypes");
var ApartmentInfo = function (_a) {
    var postData = _a.postData, isRent = _a.isRent;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeader_1.default, { title: postData.propertyType === PostViewContentTypes_1.SECTION_TYPES.HOUSE_INFO
                ? t('POST_PREVIEW.HOUSE_PROPERTY')
                : postData.propertyType ===
                    PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO
                    ? t('POST_PREVIEW.APARTMENT_PROPERTIES')
                    : postData.propertyType ===
                        PostViewContentTypes_1.SECTION_TYPES.COMMERCIAL_INFO
                        ? t('POST_PREVIEW.COMMERCIAL_PROPERTY')
                        : t('POST_PREVIEW.APARTMENT_PROPERTIES') }),
        postData.sections.apartment_info.map(function (item, index) {
            var _a;
            return (react_1.default.createElement("div", { key: index }, item.amenities && (react_1.default.createElement(react_1.Fragment, { key: index },
                postData.sections.apartment_info.length >
                    1 && (react_1.default.createElement("h4", null,
                    t('POST_PREVIEW.APARTMENT_TYPE'),
                    ' ',
                    index + 1)),
                react_1.default.createElement(AmenityList_1.default, { amenities: item.amenities }),
                isRent && !!((_a = item.animals) === null || _a === void 0 ? void 0 : _a.length) && (react_1.default.createElement(AnimalsRow_1.default, { animals: item.animals }))))));
        })));
};
exports.default = ApartmentInfo;
